import httpClient from "../../../../api/httpClient";
// eslint-disable-next-line no-unused-vars
import { convertDateToUTC, convertTimeToUTC } from "../utils/formatters"; // Must convert to UTC before sending, don't delete
import { API_BASE_URL } from "./contractApi.js";
import Cookies from "js-cookie";

export const laneApi = {
  createLane: (officeCode, laneDTO) =>
    httpClient.post(`${API_BASE_URL}/organizations/${officeCode}/lanes`, laneDTO),

  getLaneById: (officeCode, id) =>
    httpClient.get(`${API_BASE_URL}/organizations/${officeCode}/lanes/${id}`),

  filterSingleOfficeCodeLanes: (officeCode, criteria, pageable) => {
    const params = {
      page: pageable?.page || 0,
      size: pageable?.size || 15,
      sort: pageable?.sort || "id,asc",
    };
    return httpClient.post(
      `${API_BASE_URL}/organizations/${officeCode}/lanes/filter`,
      criteria,
      { params }
    );
  },

  filterLanes: (officeCode, criteria, pageable) => {
    const token = Cookies.get("authToken");
    const officeCodesCookie = Cookies.get("officeCodes");
    const officeCodes = officeCodesCookie ? officeCodesCookie.split(",") : [];

    const params = {
      officeCodes: officeCodes.join(","),
      page: pageable?.page || 0,
      size: pageable?.size || 15,
      sort: pageable?.sort || "id,asc",
    };
    return httpClient.post(
      `${API_BASE_URL}/organizations/${officeCode}/lanes/filter-for-multioffice`,
      criteria,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params,
        paramsSerializer: { indexes: null },
      }
    );
  },

  searchLanes: (request, pageable) => {
    const token = Cookies.get("authToken");
    const officeCodesCookie = Cookies.get("officeCodes");
    const officeCodes = officeCodesCookie ? officeCodesCookie.split(",") : [];

    const params = {
      page: pageable?.page ?? 0,
      size: pageable?.size ?? 15,
      sortBy: pageable?.sortBy ?? "updatedAt",
      ascending: pageable?.ascending ?? false,
    };

    const criteria = {
      query: request?.query || "",
      status: "",
      // Nested AND/OR advanced-filter FilterNode tree (null/absent preserves the plain search)
      ...(request?.filter ? { filter: request.filter } : {}),
    };

    return httpClient.post(
      `${API_BASE_URL}/partial-details/lane-search`,
      // `criteria` should match your `SearchRequest` shape (e.g., { query: "..." })
      criteria,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          // Spring will bind a comma-separated header into List<String>
          "Office-Code": officeCodes.join(","),
        },
        params,
        paramsSerializer: { indexes: null },
      }
    );
  },

  updateLane: (officeCode, laneDTO, token) =>
    httpClient.put(
      `${API_BASE_URL}/organizations/${officeCode}/lanes/update`,
      laneDTO,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    ),

  deleteLane: (officeCode, id) =>
    httpClient.delete(`${API_BASE_URL}/organizations/${officeCode}/lanes/${id}`),

  checkLaneExists: (officeCode, id) =>
    httpClient.head(`${API_BASE_URL}/organizations/${officeCode}/lanes/${id}`),

  // Type-ahead search over the office's real facilities, for picking an existing via point
  // instead of retyping its address (and risking a near-duplicate Location).
  searchFacilities: (officeCode, query) =>
    httpClient.get(`${API_BASE_URL}/locations/search-facilities`, {
      params: { officeCode, query },
    }),
};
